import { renderPageToDataURL } from './pdfjs.js'

// Export pages from a list of "entries" (documents+pageState) as PNG/JPG files.
// Returns a list of { name, blob } objects. The caller decides whether to
// download each individually or zip them.

function dataUrlToBlob(dataUrl) {
  const [header, base64] = dataUrl.split(',')
  const mime = /data:([^;]+)/.exec(header)?.[1] || 'application/octet-stream'
  const bin = atob(base64)
  const arr = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i += 1) arr[i] = bin.charCodeAt(i)
  return new Blob([arr], { type: mime })
}

export async function renderOrderedPagesToImages(
  documents,
  pageOrder,
  { format = 'png', dpi = 144, onProgress } = {}
) {
  const docMap = new Map(documents.map((d) => [d.id, d]))
  // Each PDF point = 1/72 inch, so px = pt * dpi / 72.
  const scale = dpi / 72

  const tasks = []
  for (const pid of pageOrder) {
    for (const d of documents) {
      const p = d.pages.find((x) => x.id === pid)
      if (p && p.included) tasks.push({ doc: d, page: p })
    }
  }

  const results = []
  for (let i = 0; i < tasks.length; i += 1) {
    const { doc, page } = tasks[i]
    onProgress && onProgress({ index: i, total: tasks.length, name: doc.originalName })

    const targetWidthPx = Math.max(1, Math.round(page.width * scale))
    const { dataUrl } = await renderPageToDataURL(
      doc.id,
      doc.bytes,
      page.originalIndex + 1,
      { maxWidth: targetWidthPx, scale }
    )

    let outUrl = dataUrl
    if (format === 'jpg' && dataUrl.startsWith('data:image/png')) {
      // Re-encode to JPG on a canvas
      outUrl = await new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(img, 0, 0)
          resolve(canvas.toDataURL('image/jpeg', 0.85))
        }
        img.onerror = reject
        img.src = dataUrl
      })
    }

    const ext = format === 'jpg' ? 'jpg' : 'png'
    const stem = (doc.originalName || 'page').replace(/\.pdf$/i, '')
    const name = `${stem}-p${page.originalIndex + 1}.${ext}`
    results.push({ name, blob: dataUrlToBlob(outUrl) })
  }

  onProgress && onProgress({ index: tasks.length, total: tasks.length, name: '' })
  return results
}
